import styled from 'styled-components';
import { Box } from '../../../../../../../../CommonComponents/OPL/Box/Box';

interface Props {
  isOver: boolean;
}

export const Dropzone = styled(Box)<Props>(({ isOver, theme }) => ({
  display: 'flex',
  flex: 1,
  alignItems: 'center',
  justifyContent: 'center',
  border: `1px dashed ${isOver ? theme.colors.neutral[500] : theme.colors.neutral[300]}`,
  borderRadius: theme.radii.medium,
  background: isOver ? theme.colors.neutral[100] : theme.colors.bg,
  padding: '24px 16px',
}));
